var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Auth',{on:{"loginFailed":_vm.onFailedAuthentication}},[_c('Header',{attrs:{"content":_vm.headerContent}}),_c('div',{staticClass:"wrap-tmp f fh"},[_c('span',[_vm._v("tmp")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }